import React from 'react';

interface FooterProps {
  onNavigate: (path: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-400">Discover</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => onNavigate('/')}
                  className="text-white hover:text-gray-300 transition-colors font-medium flex flex-wrap items-center gap-2"
                >
                  <span className="inline-block">Chinese Food Near Me</span>
                  <img 
                    src="https://cdn-icons-png.flaticon.com/512/661/661740.png" 
                    alt="Chinese Food icon" 
                    className="w-6 h-6"
                  />
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/history')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Chinese Food History
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/chinese-food-facts')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Chinese Food Facts
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/chinese-food-quiz')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Chinese Food Quiz
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/faq')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-400">Popular Recipes</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/kung-pao-chicken')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Kung Pao Chicken
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/mapo-tofu')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Mapo Tofu
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/dim-sum')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Dim Sum
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/chow-mein')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Chow Mein
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/fried-rice')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Fried Rice
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/hot-pot')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Hot Pot
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/beef-and-broccoli')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Beef and Broccoli
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/sweet-and-sour-pork')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Sweet and Sour Pork
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/egg-foo-young')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Egg Foo Young
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/chinese-dumplings')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Chinese Dumplings
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/recipes/general-tso-chicken')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  General Tso's Chicken
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-400">Legal</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => onNavigate('/privacy')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate('/terms')}
                  className="text-white hover:text-gray-300 transition-colors font-medium"
                >
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white font-medium">
              &copy; {new Date().getFullYear()} Chinese Food Maps. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <button 
                onClick={() => onNavigate('/about')}
                className="text-gray-400 hover:text-white transition-colors"
              >
                About Us
              </button>
              <button 
                onClick={() => onNavigate('/contact')}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Contact
              </button>
              <a 
                href="https://sushimaps.app"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
              >
                <img 
                  src="https://cdn-icons-png.flaticon.com/512/3259/3259012.png"
                  alt="Sushi Maps icon"
                  className="w-5 h-5"
                />
                Sushi Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};